import { query } from 'src/utils/request';
// 单位账户列表查询
//
export async function queryUnitAccountList(data) {
  return query('/zlb/api/pay/bankCard/org/list', {
    method: 'POST',
    data,
  });
}
// 单位账户同步
//
export async function syncUnitAccount(data) {
  return query('/zlb/api/pay/tuoshou/balance/sync', {
    method: 'POST',
    data,
  });
}
